import toast from "react-hot-toast";
import * as api from "../Api";

export const createInvestmentType = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Creating investment type...");
    const { data } = await api.createInvestmentTypes(postData);
    dispatch({ type: "CREATE_INVESTMENT_TYPE", payload: data });
    toast.remove(creatingId);
    toast.success("Investment type created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const getAllInvestmentTypes = () => async (dispatch) => {
  try {
    const { data } = await api.getInvestmentTypes();
    dispatch({ type: "GET_INVESTMENT_TYPE", payload: data });
  } catch (error) {}
};

export const deleteInvestmentType = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting investment type...");
    await api.deleteInvestmentTypes(id);
    dispatch({ type: "NEW_INVESTMENT_TYPE_TO_BE_DELETED", payload: id });
    toast.remove(deletingId);
    toast.success("Investment type deleted successfully");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
